import { useCallback } from 'react'
import type { CalendarEvent } from '@highlight/common'
import { Button } from '@highlight/ui'
import { Toast, useToast } from '@renderer/overlay/Toaster'
import { ADD_HOURS_TO_TRANSCRIBE_CTA, OUT_OF_MEETING_HOURS_COPY, useOpenHoursPaywall } from './out-of-meeting-hours'

interface OutOfMeetingHoursToastProps {
  toastId: string
  /** The meeting the hours were for. Its view docks the paywall when it can. */
  calendarEvent?: CalendarEvent
}

/** The one way into the meeting-hours paywall from a toast. Nothing opens without this click. */
export function OutOfMeetingHoursToast({ toastId, calendarEvent }: OutOfMeetingHoursToastProps) {
  const toast = useToast()
  const openHoursPaywall = useOpenHoursPaywall()

  const handleAddHours = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      openHoursPaywall(calendarEvent)
      toast.dismiss(toastId)
    },
    [openHoursPaywall, calendarEvent, toast, toastId],
  )

  return (
    <Toast toastId={toastId}>
      <Toast.Content>
        <Toast.Footer>
          <span>{OUT_OF_MEETING_HOURS_COPY}</span>
          <Button onClick={handleAddHours} size="sm" variant="primary">
            {ADD_HOURS_TO_TRANSCRIBE_CTA}
          </Button>
        </Toast.Footer>
      </Toast.Content>
    </Toast>
  )
}
